import { mdiMagnifyPlusOutline } from '@mdi/js';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomInButton extends Command {
    constructor() {
        const isEnabled = true;
        // ToDO: if (GlobalVariables.docRender !== undefined) {
        //   isEnabled = GlobalVariables.getPDFPageRenderScale() < GlobalVariables.docRender.pdfViewer.config.maxScale;
        // }

        const key = 'zoomIn';
        GlobalVariables.registeredCommands[key] = () => {
            GlobalVariables.zoom('in');
        };

        super({
            Enabled: isEnabled,
            Key: key,
            Path: mdiMagnifyPlusOutline,
            Callback: GlobalVariables.registeredCommands[key],
        });
    }
}
